export default __webpack_public_path__ + "static/media/img-0516-croatia-half-face.329a8d93.png";